// extracted by mini-css-extract-plugin
export default {"loader":"style_loader__o7IUK","lds-ring":"style_lds-ring__wrNzv"};